// extracted by mini-css-extract-plugin
module.exports = {"header":"HistoryPage_header__3ikqG","content":"HistoryPage_content__3-ujm"};